export default __webpack_public_path__ + "static/media/project-on-track-health.325dba54.svg";